import React from "react";
import { Box, Grid, Skeleton } from "@mantine/core";
import useStyles from "./style";

const DashboardAnalytics = ({ data, loading }) => {
  // console.log("🚀 ~ DashboardAnalytics ~ data:", data);
  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.parentBox}>
        <Box className={classes.childBox}>
          <Box className={classes.grandChild}>
            <Grid className={classes.gridStyling}>
              <Grid.Col
                className={classes.gridBorder}
                xs={12}
                sm={6}
                md={6}
                lg={3}
                xl={3}
              >
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling}>
                    {data?.taskCompleteCount?.toString().padStart(2, "0") ||
                      "00"}
                  </Box>
                )}
                <small> Completed Task</small>
              </Grid.Col>
              <Grid.Col
                className={`${classes.specialGridBorder} ${classes.gridPaddingLeft}`}
                xs={12}
                sm={6}
                md={6}
                lg={3}
                xl={3}
              >
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling}>
                    {data?.noteCompleteCount?.toString().padStart(2, "0") ||
                      "00"}
                  </Box>
                )}
                <small> Completed Note</small>
              </Grid.Col>
              <Grid.Col
                className={`${classes.gridBorder} ${classes.gridPaddingLeft}`}
                xs={12}
                sm={6}
                md={6}
                lg={3}
                xl={3}
              >
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling}>
                    {data?.staffHourWorkCount || "00"}
                  </Box>
                )}
                <small>Total Hours Worked</small>
              </Grid.Col>
              <Grid.Col
                className={`${classes.gridPaddingLeft}`}
                xs={12}
                sm={6}
                md={6}
                lg={3}
                xl={3}
              >
                {loading ? (
                  <Skeleton visible={loading} height={35} width={35} />
                ) : (
                  <Box className={classes.numbersStyling}>
                    {data?.medicationGivenCount?.toString().padStart(2, "0") ||
                      "00"}
                  </Box>
                )}
                <small>Medication Given</small>
              </Grid.Col>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DashboardAnalytics;
